import axios from '@/axios'
import * as types from '../mutation-types';

export default {
	namespaced: true,

	state: {
		teachers: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/teacher/brief', { once: true }).then(({ data }) => {
				commit(types.STORE_TEACHERS, data);
				return data;
			})
		},
	},

	mutations: {
		[types.STORE_TEACHERS](state, teachers) {
			state.teachers = teachers;
		}
	},

	getters: {
		getTeacherById: state => id => state.teachers.find(c => c.id === id)
	}
}